"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewedCell = void 0;
const react_1 = __importDefault(require("react"));
const graphql_1 = require("../../../../../../../__generated__/graphql");
const reviewed_cell_styles_1 = require("./reviewed-cell.styles");
const product_1 = require("../../../../../../client/product");
const ReviewedCell = ({ reviewed, attribute, attributeType, productId, disabled, onReviewStatusChange, }) => {
    const { onSetProductReviewStatus, loading, } = (0, product_1.useProductReviewStatus)();
    const onCheckBoxClick = (e) => {
        e.stopPropagation();
    };
    const handleReview = () => {
        const isCurrentlyReviewed = reviewed === graphql_1.ProductAttributeReviewStatus.Reviewed;
        const status = isCurrentlyReviewed
            ? graphql_1.ProductAttributeReviewStatus.NotReviewed
            : graphql_1.ProductAttributeReviewStatus.Reviewed;
        const mutation = onSetProductReviewStatus({
            productId,
            attribute,
            attributeType,
            clientMutationId: '',
            status,
        });
        onReviewStatusChange === null || onReviewStatusChange === void 0 ? void 0 : onReviewStatusChange({ mutation, productId, status });
    };
    return (react_1.default.createElement(reviewed_cell_styles_1.StyledCheckbox, { onClick: onCheckBoxClick, handleChange: handleReview, checked: reviewed === graphql_1.ProductAttributeReviewStatus.Reviewed, disabled: loading || disabled }));
};
exports.ReviewedCell = ReviewedCell;
